import http from "@/request"
import { removeTokenAndInfo } from '@/cookie';
import { Message } from 'element-ui';


/**
 * 登录接口
 * @param {*} param 
 * @returns 
 */
export function login(param) {
    return http({
      url: "/login",
      method: "post",
      data: param,
    });
}


/**
 * 设置验证码
 * @param {*} param 
 * @returns 
 */
export function sendVerifyCode(param) {
    return http({
      url: "/sendCode",
      method: "post",
      data: param,
    });
}

/**
 * 退出
 */
export function logout(){
  let _this = this;
  http({
    url: "/logout",
    method: "get",
  }).then(res => {
     console.log( res );
     if(res.code == 200){
        removeTokenAndInfo();
        window.location.href = '/';
     } else {
        Message.error(res.msg);
     }
  });
}

/**
 * 系统账户
 * @param {*} param 
 * @returns 
 */
export function listSysAccount(param) {
  return http({
    url: "/baseUser/sys-account-list",
    method: "post",
    data: param,
  });
}

/**
 * 编辑账户
 * @param {*} param 
 * @returns 
 */
export function editorAccount(param) {
  return http({
    url: "/editor",
    method: "post",
    data: param,
  });
}

/**
 * 保存系统用户
 * @param {*} param 
 * @returns 
 */
export function saveSystemAccount(param) {
  return http({
    url: "/saveSystemAccount",
    method: "post",
    data: param,
  });
}

/**
 * 重置管理员密码
 * @param {*} param 
 * @returns 
 */
export function resetSystemAccountPassword(param) {
  return http({
    url: "/resetSystemAccountPassword",
    method: "post",
    data: param,
  });
}

/**
 * 删除系统账户
 * @param {*} param 
 * @returns 
 */
export function deleteAccountById(param) {
  return http({
    url: "/deleteAccountById",
    method: "post",
    data: param,
  });
}

/**
 * 是否是系统管理员
 * @returns 
 */
export function isSystemAdmin() {
  return http({
    url: "/isSystemAdmin",
    method: "get",
  });
}

/**
 * 是否是单位管理员
 * @returns 
 */
export function isUnitAdmin() {
  return http({
    url: "/isUnitAdmin",
    method: "get",
  });
}



// WEBPACK FOOTER //
// ./src/api/account.js